export const MAX_CONNECTIONS_COUNT = 80;
